import { FieldValues } from 'react-hook-form';
import TextInput, { TextInputProps } from './TextInput';

const PhoneNumberInput = <T extends FieldValues>(props: TextInputProps<T>) => {
    return <TextInput pattern="^[+]?[0-9\s\-\(\)]*$" {...props} />;
};

export default PhoneNumberInput;
